import {observer} from 'mobx-react';
import {Route, Switch} from 'react-router-dom';
import {withState} from 'shared/core';
import NmbrPageState from '../state/NmbrPageState';
import {NmbrPayrollContainer} from './manage';
import {NmbrEmployeesDirectory} from './employees';
import {NmbrUpdatesDirectory} from './updates';

const NmbrPage = observer(({uiState}) => {
  const {erroredNmbrEmployees} = uiState;

  return (
    <Switch>
      <Route exact path='/' render={() => <NmbrPayrollContainer erroredNmbrEmployees={erroredNmbrEmployees}/>}/>
      <Route path='/employees' render={() => <NmbrEmployeesDirectory erroredNmbrEmployees={erroredNmbrEmployees}/>}/>
      <Route path='/updates' render={() => <NmbrUpdatesDirectory erroredNmbrEmployees={erroredNmbrEmployees}/>}/>
    </Switch>
  );
});

export default withState(NmbrPage, NmbrPageState);
